import { message } from "antd";
import { getIdToken } from "../../../userManager/userManagementUtils";
import { handleResponse } from "../../../../common/handleLambdaResponse";

export const getTransactionLog = (startTime: number | undefined, endTime: number | undefined): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get transaction log")
            reject(err);
        }
        const payload : any = {
            action: "list_by_user",
            token: idToken,
        }
        if(startTime) {
            payload["start_time"] = startTime;
        }
        if(endTime) {
            payload["end_time"] = endTime;
        }
        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
           handleResponse(err, resp, resolve, reject)
        }
        )
    })
}

export const get_viewable_billing_groups = (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get transaction log")
            reject(err);
        }
        const payload = {
            action: "get_viewable_billing_groups",
            token: idToken,
        }
        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject)
        }
        )
    })
}

export const list_by_billing_group = (billing_group: string | null, startTime: number | undefined, endTime: number | undefined): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Failed to get transaction log")
            reject(err);
        }
        const payload : any = {
            action: "list_by_billing_group",
            token: idToken,
        }

        if(startTime) {
            payload["start_time"] = startTime;
        }
        if(endTime) {
            payload["end_time"] = endTime;
        }
        if(billing_group) {
            payload["billing_group"] = billing_group;
        }

        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject)
        }
        )
    })
}

export const dispute_transaction = (billingGroupId: string, transactionID: string, disputeMessage: string): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error fetching data")
            reject(err);
        }
        const payload = {
            action: "dispute_transaction",
            billing_group: billingGroupId,
            transaction_id: transactionID,
            dispute_message: disputeMessage,
            token: idToken,
        }

        const params = {
            FunctionName: "transaction-log",
            Payload: JSON.stringify(payload)
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject)
        }
        )
    })
}

